<template>
  <div>
    <v-dialog
      v-model="show"
      max-width="700"
      max-height="500"
    >
      <v-card dark>
        <v-toolbar flat>
          <v-toolbar-title>
            Your saved searches
            <!-- <sup>
              <font
                size="2"
                color="#f7184d"
                style="margin-top: 50px;"
              >
                New
              </font>
            </sup> -->
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="show = false" icon style="outline: none;">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- <v-card-title
          class="headline"
          primary-title
        >
          Your saved searches
        </v-card-title> -->

        <v-tabs v-model="selectedCategory">
          <v-tab
            v-for="category in categories"
            :key="category"
          >
            {{ category }}
          </v-tab>

          <v-tab-item
            v-for="category in categories"
            :key="category"
          >
            <Custom
              v-if="category === 'Custom'"
              :fields="fields" />

            <v-card-text style="height: 500px; overflow: auto;" v-else>
              <v-list
                two-line
                dark
              >
                <v-list-tile
                  v-for="command in savedCommands"
                  :key="command._id"
                  ripple
                  @click="noOp"
                >
                  <v-list-tile-content
                    @click="search(command.command)"
                  >
                    <v-list-tile-title>
                      {{ command.name }}
                    </v-list-tile-title>

                    <v-list-tile-sub-title>
                      {{ command.description }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-layout row>
                      <v-flex>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              :disabled="user === 'demo'
                                ? false
                                : command.defaultCommand
                              "
                              icon
                              v-on="on"
                              style="outline: none;"
                              @click="commitEdit(command)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>

                          <span>Edit</span>
                        </v-tooltip>
                      </v-flex>

                      <v-flex>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              :disabled="user === 'demo'
                                ? false
                                : command.defaultCommand
                              "
                              icon
                              v-on="on"
                              style="outline: none;"
                              @click.stop="
                                deleting = true;
                                deletingQueryId = command._id
                              "
                            >
                              <v-icon color="error">delete_forever</v-icon>
                            </v-btn>
                          </template>

                          <span>Delete</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-tab-item>
        </v-tabs>

        <v-card-actions style="justify-content: center;">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                large
                icon
                style="outline: none;"
                color="light-blue darken-4"
                v-on="on"
                @click="commitOpen()"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </template>

            <span>Close</span>
          </v-tooltip>
          <!-- <v-spacer />

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                large
                icon
                color="error"
                v-on="on"
                @click="show = false"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </template>

            <span>Close</span>
          </v-tooltip> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleting"
      max-width="290"
    >
      <v-card dark>
        <v-toolbar flat>
          <v-toolbar-title>
            Are you sure?
          </v-toolbar-title>
        </v-toolbar>
        <!-- <v-card-title class="headline">
          Are you sure?
        </v-card-title> -->

        <v-card-text>
          This action cannot be undone.
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            flat
            small
            style="outline: none;"
            @click="deleting = false"
          >
            Cancel
          </v-btn>

          <v-btn
            flat
            small
            color="error"
            style="outline: none;"
            @click="commitDelete"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleted"
      max-width="250"
    >
      <v-card dark>
        <v-toolbar flat>
          <v-toolbar-title>
            Delete Complete
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          {{ deletedResponse }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            flat
            style="outline: none;"
            @click="deleted = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from 'axios'

import SavedQueryCustom from '@/components/SavedQueryCustom'

export default {
  name: 'DialogQuickSearch',

  components: {
    'Custom': SavedQueryCustom
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },

    user: {
      type: String,
      default: ''
    },

    fields: {
      type: Array,
      default: () => ([])
    },

    savedSearches: {
      type: Array,
      default: () => ([
        {
          _id: '',
          name: '',
          savedCommands: [
            {
              _id: '',
              name: '',
              description: '',
              command: ''
            }
          ]
        }
      ])
    }
  },

  data () {
    return {
      selectedCategory: 0,
      deleting: false,
      deleted: false,
      deletingQueryId: '',
      deletedResponse: ''
    }
  },

  computed: {
    show: {
      get () {
        return this.value
      },
      set (show) {
        this.$emit('input', show)
      }
    },

    categories: {
      get () {
        return this.savedSearches.map(savedCategory => {
          return savedCategory.name
        })
      }
    },

    savedCommands: {
      get () {
        return this.savedSearches[this.selectedCategory].savedCommands
      }
    },

    currentCategoryId: {
      get () {
        return this.savedSearches[this.selectedCategory]._id
      }
    }
  },

  methods: {
    noOp () {

    },

    search (command) {
      this.$emit('search', command)
      this.show = false
    },

    commitEdit (command) {
      const categoryId = this.currentCategoryId
      const editingCommand = {
        ...command,
        categoryId
      }
      this.$emit('edit-saved-search', editingCommand)
    },
    commitOpen () {
      this.$emit('open-saved-search')
    },
    async commitDelete () {
      const categoryId = this.currentCategoryId
      const commandId = this.deletingQueryId
      const response =
        await Axios.delete(`${apiUrl}/api/dashboard/saved-searches/${
          categoryId}/${commandId}`)
          .catch(error => alert(error))
      this.deleting = false
      this.deletedResponse = response.data.message
      this.deleted = true
      this.$emit('get-saved-searches')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SavedQuery.vue